import { useQuery } from '@tanstack/react-query';
import type { ActivityItem, DashboardOverview, DashboardPeriod } from '@crm/shared';
import { api } from '../../api/client';

export interface DashboardStats {
  contacts: number;
  organizations: number;
  openDeals: number;
  campaignsSent: number;
  tasksDue: number;
  recent: ActivityItem[];
  openDealValue: number;
  trends: Record<'contacts' | 'deals' | 'campaigns', { thisMonth: number; lastMonth: number }>;
  pipeline: { id: string; name: string; stages: { id: string; name: string; color: string | null; kind: 'OPEN' | 'WON' | 'LOST'; count: number; value: number }[] } | null;
  topOrganizations: { id: string; name: string; domain: string | null; deals: number; value: number }[];
}

export function useDashboardStats(enabled = true) {
  return useQuery({ queryKey: ['dashboard'], queryFn: async () => (await api.get<DashboardStats>('/dashboard/stats')).data, enabled });
}

/** The dashboard's boxes for this week or this month; refreshed every minute while open. */
export function useDashboardOverview(period: DashboardPeriod) {
  return useQuery({
    queryKey: ['dashboard-overview', period],
    queryFn: async () => (await api.get<DashboardOverview>('/dashboard/overview', { params: { period } })).data,
    refetchInterval: 60_000,
    placeholderData: (prev) => prev,
  });
}
